import { useState } from 'react';
import { collection, addDoc, deleteDoc, doc } from 'firebase/firestore';
import { firebaseDB } from '../firebase/config';
import { Notification } from '../firebase/entities';

const useDeleteUser = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteUser = async (userId: string) => {
    setLoading(true);
    setError(null);

    try {
      if (!userId) {
        throw new Error('Invalid user id');
      }

      const usersCollection = collection(firebaseDB, 'users');
      
      const userDocRef = doc(usersCollection, userId);
      deleteDoc(userDocRef);
      
    } catch (err) {
      setError('Error creating notification');
    } finally {
      setLoading(false);
    }
  };

  return { deleteUser, loading, error };
};

export default useDeleteUser;